<template>
    <b-modal id="suscripcionesMonitor" v-model="display" size="lg" @close="close">

        <!-- TITULO -->
        <template #modal-title>
            <span v-if="isLoading">Cargando...</span>
            <template v-else>
                <div class="plan-name">
                    {{ data.suscriptionObj.mainQueryItem.planName }}
                    <div class="b-pill inline">{{ data.suscriptionObj.mainQueryItem.estatus | suscriptionStatusReNamer}}</div>
                </div>
            </template>
        </template>

        <!-- SPINNER DE CARGA -->
        <div v-if="isLoading" class="text-center p-5">
            <b-spinner label="isLoading..."></b-spinner>
        </div>
        <!-- SPINNER DE CARGA -->

        <!-- CONTENIDO MOSTRADO EN COLUMNAS -->
        <template v-else>

            <b-row>
                <b-col lg="4">
                    <b-card class="mb-3" v-if="data.stripeInvoice && data.stripeInvoice.id">
                        <b-card-title class="invoice-title">Factura actual</b-card-title>
                        <dl>
                            <dt>Folio</dt>
                            <dd>{{ data.stripeInvoice.number || '-' }}</dd>
                            <dt>Fecha de emisión</dt>
                            <dd>
                                <span v-if="data.stripeInvoice.created">
                                    {{ new Date(data.stripeInvoice.created * 1000).toLocaleString() }}
                                </span>
                                <span v-else>-</span>
                            </dd>
                            <dt>Monto total</dt>
                            <dd>
                                <span v-if="data.stripeInvoice.total">
                                    {{
                                        (data.stripeInvoice.total / 100).toLocaleString('es-MX', {
                                            style: 'currency',
                                            currency: data.stripeInvoice.currency.toUpperCase()
                                        })
                                    }}
                                </span>
                                <span v-else>-</span>
                            </dd>
                            <dt>Monto a pagar</dt>
                            <dd>
                                <strong>{{
                                    (data.stripeInvoice.amount_due / 100).toLocaleString('es-MX', {
                                        style: 'currency',
                                        currency: data.stripeSuscription.currency.toUpperCase()
                                    })
                                }}</strong>
                            </dd>
                            <dt>Estatus de pago</dt>
                            <dd>
                                {{
                                    {
                                        'draft': 'Borrador',
                                        'open': 'Pago pendiente',
                                        'paid': 'Pagada',
                                        'uncollectible': 'Incobrable',
                                        'void': 'Anulada'
                                    }[data.stripeInvoice.status] || data.stripeInvoice.status || '-'
                                }}
                            </dd>
                        </dl>

                    </b-card>
                    <b-card class="mb-3" v-if="data.stripeInvoice && data.stripeInvoice.amount_due && !isNuevaSuscripcion">
                        <b-card-title class="invoice-title">Suscripción</b-card-title>
                        <dl>
                            <dt>Fecha de inicio</dt>
                            <dd>
                                <span v-if="data.stripeSuscription.start_date">
                                    {{ new Date(data.stripeSuscription.start_date * 1000).toLocaleString() }}
                                </span>
                                <span v-else>-</span>
                            </dd>
                            <dt>Código de Stripe</dt>
                            <dd>
                                <span v-if="data.stripeSuscription.id">
                                    {{ data.stripeSuscription.id }}
                                </span>
                                <span v-else>-</span>
                            </dd>
                            <dt>Líneas</dt>
                            <dd>
                                {{ data.suscriptionObj.usuariosDN.length }} línea(s)
                            </dd>
                            <template v-if="data.stripeSuscription.current_period_end">
                                <dt>Próximo cobro</dt>
                                <dd v-if="data.suscription.subscription.cancel_at_period_end">
                                    <div class="b-pill danger">Cancelado al corte.</div>
                                </dd>
                                <dd v-else>
                                    {{ new Date(data.stripeSuscription.current_period_end * 1000).toLocaleString() }}
                                </dd>
                            </template>
                        </dl>
                    </b-card>
                </b-col>
                <b-col lg="8">
                    <ui-tabs v-model="selectedTab" :options="tabsOptions" class="mb-3" disable-button-mode/>
                    <saldo just-index :suscription-id="data.suscriptionObj.id">
                        <b-jumbotron slot="no-numeros" v-if="visualizaBotonPago" 
                            header="No tienes números BlackFon" 
                            lead="Por favor, finaliza la suscripción para que se asignen los números.">
                            <b-button :href="data.stripeInvoice.hosted_invoice_url" 
                                target="_blank" variant="primary">
                                Finalizar pago
                                <i class="fa fa-external-link-alt" />
                            </b-button>
                            <div class="block mt-3">
                                <i>Si ya realizaste el pago, por favor espera unos minutos y recarga la ventana.</i>
                            </div>
                        </b-jumbotron>
                        <b-jumbotron slot="no-numeros" v-else-if="isPaid" 
                            header="Estamos procesando la compra" 
                            lead="Por favor, espera unos minutos y recarga la ventana." />
                    </saldo>
                </b-col>
            </b-row>

            <div class="debug" v-if="debug">
                <pre>{{ data | json }}</pre>
            </div>

        </template>
        <!-- CONTENIDO MOSTRADO EN COLUMNAS -->


        <!-- MODAL FOOTER -->
        <template #modal-footer>
            <b-button-group v-if="!isLoading && data.suscriptionObj">
                <b-button v-if="!parseInt(data.suscriptionObj.renovacion)" variant="success" :disabled="isLoading"
                    @click="askBeforeResume">
                    Reanudar
                </b-button>
                <b-button v-else-if="!isNuevaSuscripcion" variant="danger" :disabled="isLoading" @click="showCancelModal = true">
                    Cancelar suscripción
                </b-button>
                <b-button v-else-if="isNuevaSuscripcion" variant="primary" :disabled="isLoading" @click="loadUp">
                    Recargar ventana
                </b-button>
                <b-button v-if="data.stripeInvoice.status != 'paid' && data.stripeInvoice.hosted_invoice_url" 
                    :href="data.stripeInvoice.hosted_invoice_url" 
                    target="_blank" variant="primary">
                    Finalizar pago
                </b-button>
                <b-button v-else-if="data.stripeInvoice.invoice_pdf" :href="data.stripeInvoice.invoice_pdf" 
                    target="_blank" variant="secondary">
                    Descargar comprobante
                </b-button>
            </b-button-group>
        </template>
        <!-- MODAL FOOTER -->

        <!-- CANCELING MODAL -->
        <b-modal id="cancelSubscriptionModal" v-model="showCancelModal" title="Cancelar suscripción" hide-footer>
            <b-card class="mb-3 highlightOnHover" @click="cancelType = 'period_end'"
                :border-variant="cancelType === 'period_end' ? 'warning' : ''"
                :bg-variant="cancelType === 'period_end' ? 'warning' : ''">
                <b-form-radio v-model="cancelType" value="period_end">
                    CANCELACIÓN AL CORTE
                </b-form-radio>
                <b-card-text class="mt-2">
                    <strong>Descripción:</strong>
                    Esta opción le permite seguir disfrutando del servicio hasta la fecha de corte ya pagada. No se
                    realizarán
                    más cargos a menos que la suscripción sea reanudada. Usted puede reanudar la suscripción en
                    cualquier
                    momento antes de la fecha de corte.
                </b-card-text>
            </b-card>
            <b-card class="mb-3 highlightOnHover" 
                @click="cancelType = 'immediate'"
                :border-variant="cancelType === 'immediate' ? 'danger' : ''"
                :bg-variant="cancelType === 'immediate' ? 'danger' : ''">
                <b-form-radio v-model="cancelType" value="immediate">
                    CANCELACIÓN INMEDIATA
                </b-form-radio>
                <b-card-text class="mt-2">
                    <strong>Descripción:</strong>
                    Esta opción cancela el servicio de todas las líneas de su suscripción de forma inmediata, sin
                    importar la
                    fecha de corte o el pago realizado. Esta acción no se puede deshacer y será necesario crear una
                    nueva
                    suscripción para reactivar las líneas canceladas.
                </b-card-text>
            </b-card>
            <div class="d-flex justify-content-end">
                <b-button variant="secondary" @click="showCancelModal = false">Cerrar</b-button>
                <b-button id="triggerCancel" variant="danger" class="ml-2" :disabled="isLoading || isProcessing"
                    @click="askBeforeCancel">
                    <span v-if="!isProcessing">Confirmar cancelación</span>
                    <span v-else>Procesando...</span>
                </b-button>
            </div>
        </b-modal>
        <!-- CANCELING MODAL -->

    </b-modal>
</template>

<script>
import UiTabs from '../ui-tabs'
import _ from 'lodash';
import axios from 'axios';
import saldo from '../../usuario-cuenta/saldo.vue';
import { notify, confirmFirst } from '../../../../utils';

const mainTab = { key: 'main', label: 'Detalles' },
    phonesTab = { key: 'phones', label: 'Líneas en la suscripción' };

const emptyData = {
    "suscriptionObj": {
        "id": "",
        "usuarios_id": "",
        "estatus": "",
        "payment_number": "",
        "start_date": null,
        "next_charge": null,
        "created": "",
        "modified": "",
        "charge_intents_left": "",
        "stripe_suscripcion_id": "",
        "ofertaspublicas_id": "",
        "mainQueryItem": {
            "id": "",
            "usuarios_id": "",
            "estatus": "",
            "payment_number": "",
            "start_date": null,
            "next_charge": null,
            "created": "",
            "modified": "",
            "charge_intents_left": "",
            "stripe_suscripcion_id": "",
            "ofertaspublicas_id": "",
            "planName": "",
            "ofertaspublicas_id_label": ""
        }
    },
    "stripeSuscription": {
        // string
        "id": "",
        // string
        "object": "",
        // null|string
        "application": null,
        // null|number
        "application_fee_percent": null,
        // object
        "automatic_tax": {
            // null|string
            "disabled_reason": null,
            // boolean
            "enabled": false,
            // null|string
            "liability": null
        },
        // number (timestamp)
        "billing_cycle_anchor": null,
        // null|object
        "billing_cycle_anchor_config": null,
        // object
        "billing_mode": {
            // string
            "type": ""
        },
        // null|object
        "billing_thresholds": null,
        // null|number (timestamp)
        "cancel_at": null,
        // boolean
        "cancel_at_period_end": false,
        // null|number (timestamp)
        "canceled_at": null,
        // object
        "cancellation_details": {
            // null|string
            "comment": null,
            // null|string
            "feedback": null,
            // null|string
            "reason": null
        },
        // string
        "collection_method": "",
        // number (timestamp)
        "created": null,
        // string
        "currency": "",
        // number (timestamp)
        "current_period_end": null,
        // number (timestamp)
        "current_period_start": null,
        // string
        "customer": "",
        // null|number
        "days_until_due": null,
        // string
        "default_payment_method": "",
        // null|string
        "default_source": null,
        // array
        "default_tax_rates": [],
        // null|string
        "description": null,
        // null|object
        "discount": null,
        // array
        "discounts": [],
        // null|number (timestamp)
        "ended_at": null,
        // object
        "invoice_settings": {
            // null|array
            "account_tax_ids": null,
            // object
            "issuer": {
                // string
                "type": ""
            }
        },
        // object
        "items": {
            // string
            "object": "",
            // array
            "data": [
                {
                    // string
                    "id": "",
                    // string
                    "object": "",
                    // null|object
                    "billing_thresholds": null,
                    // number (timestamp)
                    "created": null,
                    // number (timestamp)
                    "current_period_end": null,
                    // number (timestamp)
                    "current_period_start": null,
                    // array
                    "discounts": [],
                    // array
                    "metadata": [],
                    // object
                    "plan": {
                        // string
                        "id": "",
                        // string
                        "object": "",
                        // boolean
                        "active": false,
                        // null|object
                        "aggregate_usage": null,
                        // number
                        "amount": null,
                        // string
                        "amount_decimal": "",
                        // string
                        "billing_scheme": "",
                        // number (timestamp)
                        "created": null,
                        // string
                        "currency": "",
                        // string
                        "interval": "",
                        // number
                        "interval_count": null,
                        // boolean
                        "livemode": false,
                        // array
                        "metadata": [],
                        // null|object
                        "meter": null,
                        // null|string
                        "nickname": null,
                        // string
                        "product": "",
                        // null|string
                        "tiers_mode": null,
                        // null|object
                        "transform_usage": null,
                        // null|number
                        "trial_period_days": null,
                        // string
                        "usage_type": ""
                    },
                    // object
                    "price": {
                        // string
                        "id": "",
                        // string
                        "object": "",
                        // boolean
                        "active": false,
                        // string
                        "billing_scheme": "",
                        // number (timestamp)
                        "created": null,
                        // string
                        "currency": "",
                        // null|object
                        "custom_unit_amount": null,
                        // boolean
                        "livemode": false,
                        // null|string
                        "lookup_key": null,
                        // array
                        "metadata": [],
                        // null|string
                        "nickname": null,
                        // string
                        "product": "",
                        // object
                        "recurring": {
                            // null|object
                            "aggregate_usage": null,
                            // string
                            "interval": "",
                            // number
                            "interval_count": null,
                            // null|object
                            "meter": null,
                            // null|number
                            "trial_period_days": null,
                            // string
                            "usage_type": ""
                        },
                        // string
                        "tax_behavior": "",
                        // null|string
                        "tiers_mode": null,
                        // null|object
                        "transform_quantity": null,
                        // string
                        "type": "",
                        // number
                        "unit_amount": null,
                        // string
                        "unit_amount_decimal": ""
                    },
                    // number
                    "quantity": null,
                    // string
                    "subscription": "",
                    // array
                    "tax_rates": []
                }
            ],
            // boolean
            "has_more": false,
            // number
            "total_count": null,
            // string
            "url": ""
        },
        // string
        "latest_invoice": "",
        // boolean
        "livemode": false,
        // array
        "metadata": [],
        // null|object
        "next_pending_invoice_item_invoice": null,
        // null|string
        "on_behalf_of": null,
        // null|object
        "pause_collection": null,
        // object
        "payment_settings": {
            // null|object
            "payment_method_options": null,
            // null|array
            "payment_method_types": null,
            // string
            "save_default_payment_method": ""
        },
        // null|object
        "pending_invoice_item_interval": null,
        // null|string
        "pending_setup_intent": null,
        // null|object
        "pending_update": null,
        // object
        "plan": {
            // string
            "id": "",
            // string
            "object": "",
            // boolean
            "active": false,
            // null|object
            "aggregate_usage": null,
            // number
            "amount": null,
            // string
            "amount_decimal": "",
            // string
            "billing_scheme": "",
            // number (timestamp)
            "created": null,
            // string
            "currency": "",
            // string
            "interval": "",
            // number
            "interval_count": null,
            // boolean
            "livemode": false,
            // array
            "metadata": [],
            // null|object
            "meter": null,
            // null|string
            "nickname": null,
            // string
            "product": "",
            // null|string
            "tiers_mode": null,
            // null|object
            "transform_usage": null,
            // null|number
            "trial_period_days": null,
            // string
            "usage_type": ""
        },
        // number
        "quantity": null,
        // null|string
        "schedule": null,
        // number (timestamp)
        "start_date": null,
        // string
        "status": "",
        // null|object
        "test_clock": null,
        // null|object
        "transfer_data": null,
        // null|number (timestamp)
        "trial_end": null,
        // object
        "trial_settings": {
            // object
            "end_behavior": {
                // string
                "missing_payment_method": ""
            }
        },
        // null|number (timestamp)
        "trial_start": null
    },
    "stripeInvoice": {
        "id": "", // string
        "object": "", // string
        "account_country": "", // string
        "account_name": "", // string
        "account_tax_ids": null, // null|array
        "amount_due": null, // number
        "amount_overpaid": null, // number
        "amount_paid": null, // number
        "amount_remaining": null, // number
        "amount_shipping": null, // number
        "application": null, // null|string
        "application_fee_amount": null, // null|number
        "attempt_count": null, // number
        "attempted": false, // boolean
        "auto_advance": false, // boolean
        "automatic_tax": {
            "disabled_reason": null, // null|string
            "enabled": false, // boolean
            "liability": null, // null|string
            "provider": null, // null|string
            "status": null // null|string
        },
        "automatically_finalizes_at": null, // null|number (timestamp)
        "billing_reason": "", // string
        "charge": "", // string
        "collection_method": "", // string
        "created": null, // number (timestamp)
        "currency": "", // string
        "custom_fields": null, // null|array
        "customer": "", // string
        "customer_address": null, // null|object
        "customer_email": "", // string
        "customer_name": "", // string
        "customer_phone": "", // string
        "customer_shipping": null, // null|object
        "customer_tax_exempt": "", // string
        "customer_tax_ids": [], // array
        "default_payment_method": null, // null|string
        "default_source": null, // null|string
        "default_tax_rates": [], // array
        "description": null, // null|string
        "discount": null, // null|object
        "discounts": [], // array
        "due_date": null, // null|number (timestamp)
        "effective_at": null, // number (timestamp)
        "ending_balance": null, // number
        "footer": null, // null|string
        "from_invoice": null, // null|object
        "hosted_invoice_url": "", // string
        "invoice_pdf": "", // string
        "issuer": {
            "type": "" // string
        },
        "last_finalization_error": null, // null|object
        "latest_revision": null, // null|object
        "lines": {
            "object": "", // string
            "data": [
                {
                    "id": "", // string
                    "object": "", // string
                    "amount": null, // number
                    "amount_excluding_tax": null, // number
                    "currency": "", // string
                    "description": "", // string
                    "discount_amounts": [], // array
                    "discountable": false, // boolean
                    "discounts": [], // array
                    "invoice": "", // string
                    "livemode": false, // boolean
                    "metadata": [], // array
                    "parent": {
                        "invoice_item_details": null, // null|object
                        "subscription_item_details": {
                            "invoice_item": null, // null|string
                            "proration": false, // boolean
                            "proration_details": {
                                "credited_items": null // null|object
                            },
                            "subscription": "", // string
                            "subscription_item": "" // string
                        },
                        "type": "" // string
                    },
                    "period": {
                        "end": null, // number (timestamp)
                        "start": null // number (timestamp)
                    },
                    "plan": {
                        "id": "", // string
                        "object": "", // string
                        "active": false, // boolean
                        "aggregate_usage": null, // null|object
                        "amount": null, // number
                        "amount_decimal": "", // string
                        "billing_scheme": "", // string
                        "created": null, // number (timestamp)
                        "currency": "", // string
                        "interval": "", // string
                        "interval_count": null, // number
                        "livemode": false, // boolean
                        "metadata": [], // array
                        "meter": null, // null|object
                        "nickname": null, // null|string
                        "product": "", // string
                        "tiers_mode": null, // null|string
                        "transform_usage": null, // null|object
                        "trial_period_days": null, // null|number
                        "usage_type": "" // string
                    },
                    "pretax_credit_amounts": [], // array
                    "price": {
                        "id": "", // string
                        "object": "", // string
                        "active": false, // boolean
                        "billing_scheme": "", // string
                        "created": null, // number (timestamp)
                        "currency": "", // string
                        "custom_unit_amount": null, // null|object
                        "livemode": false, // boolean
                        "lookup_key": null, // null|string
                        "metadata": [], // array
                        "nickname": null, // null|string
                        "product": "", // string
                        "recurring": {
                            "aggregate_usage": null, // null|object
                            "interval": "", // string
                            "interval_count": null, // number
                            "meter": null, // null|object
                            "trial_period_days": null, // null|number
                            "usage_type": "" // string
                        },
                        "tax_behavior": "", // string
                        "tiers_mode": null, // null|string
                        "transform_quantity": null, // null|object
                        "type": "", // string
                        "unit_amount": null, // number
                        "unit_amount_decimal": "" // string
                    },
                    "pricing": {
                        "price_details": {
                            "price": "", // string
                            "product": "" // string
                        },
                        "type": "", // string
                        "unit_amount_decimal": "" // string
                    },
                    "proration": false, // boolean
                    "proration_details": {
                        "credited_items": null // null|object
                    },
                    "quantity": null, // number
                    "subscription": "", // string
                    "subscription_item": "", // string
                    "tax_amounts": [], // array
                    "tax_rates": [], // array
                    "taxes": [], // array
                    "type": "", // string
                    "unit_amount_excluding_tax": "" // string
                }
            ],
            "has_more": false, // boolean
            "total_count": null, // number
            "url": "" // string
        },
        "livemode": false, // boolean
        "metadata": [], // array
        "next_payment_attempt": null, // null|number (timestamp)
        "number": "", // string
        "on_behalf_of": null, // null|string
        "paid": false, // boolean
        "paid_out_of_band": false, // boolean
        "parent": {
            "quote_details": null, // null|object
            "subscription_details": {
                "metadata": [], // array
                "subscription": "" // string
            },
            "type": "" // string
        },
        "payment_intent": "", // string
        "payment_settings": {
            "default_mandate": null, // null|string
            "payment_method_options": null, // null|object
            "payment_method_types": null // null|array
        },
        "period_end": null, // number (timestamp)
        "period_start": null, // number (timestamp)
        "post_payment_credit_notes_amount": null, // number
        "pre_payment_credit_notes_amount": null, // number
        "quote": null, // null|object
        "receipt_number": null, // null|string
        "rendering": null, // null|object
        "shipping_cost": null, // null|object
        "shipping_details": null, // null|object
        "starting_balance": null, // number
        "statement_descriptor": null, // null|string
        "status": "", // string
        "status_transitions": {
            "finalized_at": null, // number (timestamp)
            "marked_uncollectible_at": null, // null|number (timestamp)
            "paid_at": null, // number (timestamp)
            "voided_at": null // null|number (timestamp)
        },
        "subscription": "", // string
        "subscription_details": {
            "metadata": [] // array
        },
        "subtotal": null, // number
        "subtotal_excluding_tax": null, // number
        "tax": null, // null|number
        "test_clock": null, // null|object
        "total": null, // number
        "total_discount_amounts": [], // array
        "total_excluding_tax": null, // number
        "total_pretax_credit_amounts": [], // array
        "total_tax_amounts": [], // array
        "total_taxes": [], // array
        "transfer_data": null, // null|object
        "webhooks_delivered_at": null // number (timestamp)
    }
};

export default {
    components: { UiTabs, saldo },
    name: 'suscripcionesMonitor',
    props: {
        tabsOptions: {
            type: Array,
            default: () => [
                // mainTab, 
                phonesTab
            ]
        },
        debug: {
            type: Boolean,
            default: false
        },
        resumingAPI: {
            type: String,
            default: 'suscripcion/reanudar'
        },
        cancelingAPI: {
            type: String,
            default: 'suscripcion/cancelar'
        },
        readingAPI: {
            type: String,
            default: 'suscripcion/define'
        }
    },
    computed: {
        isNuevaSuscripcion() {
            return this.data.suscriptionObj.mainQueryItem.estatus == 'Nueva';
        },
        isPaid() {
            return (this.data.stripeInvoice && this.data.stripeInvoice.paid);
        },
        visualizaBotonPago() {
            return (!this.isPaid && this.data.stripeInvoice.hosted_invoice_url)
            // return this.data.stripeInvoice && this.data.stripeInvoice.hosted_invoice_url && this.data.stripeInvoice.amount_due > 0 && this.data.suscriptionObj && this.data.suscriptionObj.estatus != 'Nueva';
        }
    },
    data: () => ({
        data: _.clone(emptyData),
        phonesTab, mainTab,
        selectedTab: _.clone(phonesTab.key),
        display: false,
        showCancelModal: false,
        cancelType: 'period_end', // 'period_end' o 'immediate'
        isLoading: false,
        isProcessing: false,
        suscripcionesId: null
    }),
    methods: {
        async askBeforeResume() {
            // NO DEBE CONTINUAR SI YA ESTÁ PROCESANDO.
            if (this.isProcessing)
                return;

            // CONFIRMA ANTES DE CONTINUAR
            const confirmation = await confirmFirst(
                '¿Seguro que deseas reanudar tu suscripción?',
                { title: 'Estás apunto de reanudar tu suscripción' }
            );

            if (confirmation)
                this.resumeSubscription();
        },
        async resumeSubscription() {
            this.isProcessing = true;

            // Lógica para cancelar la suscripción
            try {
                const response = await axios.patch(`${this.resumingAPI}/${this.suscripcionesId}`);

                // IS OBJECT LIKE RESPONSE
                if (!_.isObjectLike(response))
                    throw 'Ocurrió un error en la respuesta';

                if (response.status) {
                    this.showCancelModal = false;
                    this.display = false;
                    this.$emit('forceReload');
                }

                notify(response.msg, response.class);

            } catch (e) {
                notify(e);
            } finally {
                this.isProcessing = false;
            }
        },
        async askBeforeCancel() {
            // NO DEBE CONTINUAR SI YA ESTÁ PROCESANDO.
            if (this.isProcessing)
                return;

            // CONFIRMA ANTES DE CONTINUAR
            const confirmation = await confirmFirst(
                '¿Seguro que deseas continuar con la cancelación?',
                { title: 'Estás apunto de cancelar tu suscripción' }
            );

            // CONFIRMATION
            if (confirmation)
                this.cancelSubscription();

        },
        async cancelSubscription() {
            this.isProcessing = true;

            // Lógica para cancelar la suscripción
            try {
                const response = await axios.delete(`${this.cancelingAPI}/${this.suscripcionesId}/${this.cancelType}`);
                if (!_.isObjectLike(response))
                    throw 'Ocurrió un error en la respuesta';

                if (response.status) {
                    this.showCancelModal = false;
                    this.display = false;
                    this.$emit('forceReload');
                }

                notify(response.msg, response.class);

            } catch (e) {
                notify(e);
            } finally {
                this.isProcessing = false;
            }
        },
        async loadUp() {
            this.isLoading = true;
            try {
                const response = await axios.get(`${this.readingAPI}/${this.suscripcionesId}`);
                if (!_.isObjectLike(response)) {
                    throw 'Ocurrió un error en la respuesta';
                }
                if (response.status) {
                    this.data = response.data
                } else {
                    this.data = _.clone(emptyData);
                }
                // Procesar la respuesta y actualizar el estado según sea necesario
            } catch (e) {
                notify(e)
            } finally {
                this.isLoading = false;
            }
            // Lógica para cargar datos relacionados con la suscripción
            // Puedes usar this.suscripcionesId para obtener información específica
        },
        open(suscripcionesId = null) {
            if (suscripcionesId) {
                // Lógica adicional si se proporciona un ID de suscripción
                this.display = true;
                this.selectedTab = _.clone(mainTab.key);
                this.suscripcionesId = suscripcionesId;
                if(this.$route.params.suscId != suscripcionesId)
                    this.$router.replace({ name: this.$route.name, params: { ...this.$route.params, suscId: suscripcionesId } });
                this.loadUp();
            } else {
                notify('No se proporcionó un ID de suscripción');
            }
        },
        close() {
            this.display = false;
            this.$router.replace({ name: this.$route.name, params: { ...this.$route.params, suscId: null } });
            this.$emit('forceReload');
        }
    }
}
</script>

<style lang="scss">
@import '@/sass/utils/_variables.scss';

#suscripcionesMonitor {
    .b-row-inverse {
        flex-direction: row-reverse;
    }
    .plan-name {
        flex: 1 1 auto;
        display: block;
        font-weight: bold;
        color: $accent;
        // font-size: calc(1em / 1.618);
    }
    .invoice-title {
        color: $accent;
        font-weight: bold;
        font-size: 1.1em;
        margin-bottom: 0.5rem;
        padding-bottom: 0.5rem;
        border-bottom: 1px solid $accent;
    }
    dl {
        margin-bottom: 1rem;
        dt {
            font-weight: bold;
            color: inherit;
        }
        dd {
            margin-left: 0;
            color: $accent;
            font-weight: normal;
        }
    }
}
</style>